import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FileQuestion } from "lucide-react";
import { AppEmptyState } from "@/components/ui/app-empty-state";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <div className="flex min-h-[50vh] w-full flex-col items-center justify-center py-8">
      {/* ux-consistency: loading/empty C */}
      <AppEmptyState
        icon={FileQuestion}
        title={t("notFound.title")}
        description={t("notFound.message")}
        primaryAction={{
          label: t("notFound.backLink"),
          onClick: () => navigate("/crm"),
        }}
      />
    </div>
  );
};

export default NotFound;
